import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Title from '../Title/Title';
import { FilterRadio } from '../FilterRadio/FilterRadio';
import './SortRadioButtonList.less';

// eslint-disable-next-line import/prefer-default-export
export const SortRadioButtonList = ({
  list,
  title,
  handleDropDownClick,
  handleClick,
  isRowExpanded,
  selectedSortValue,
  apiKeyName,
  sortSection,
  isMobile,
}) => {
  const containerClass = cx(
    'common-filter__options-section',
    isRowExpanded ? `is-active` : ``,
    sortSection ? 'sort-section' : ''
  );

  return (
    <div className={containerClass}>
      <Title
        handleDropDownClick={handleDropDownClick}
        apiKeyName={apiKeyName}
        name={title}
        isRowExpanded={isRowExpanded}
        list={list}
        sortSection={sortSection}
        selectedSortValue={selectedSortValue}
        isMobile={isMobile}
      />

      <div className="select--facet-options sort-options">
        {list.map(({ value, title: itemTitle }, index) => (
          <FilterRadio
            key={index}
            onChange={() => handleClick(value)}
            label={itemTitle}
            selectedSortValue={selectedSortValue}
            value={value}
          />
        ))}
      </div>
    </div>
  );
};

SortRadioButtonList.propTypes = {
  apiKeyName: PropTypes.string,
  title: PropTypes.string,
  selectedSortValue: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      result_count: PropTypes.number,
      label: PropTypes.string,
      title: PropTypes.string,
    })
  ).isRequired,
  handleDropDownClick: PropTypes.func,
  handleClick: PropTypes.func,
  isMobile: PropTypes.bool,
  sortSection: PropTypes.bool,
  isRowExpanded: PropTypes.bool,
};
